import { forwardRef } from 'react'

import { styled } from 'styled-components'

import { withLabel, withFormValue } from 'peach/decorators'
import { humanizeKey } from 'peach/helpers'

const Input = styled.input`
  display: block;
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  padding: 8px 12px;
  width: ${(p) => p.width};
  color: ${(p) => p.theme.text};

  &:disabled {
    border-color: ${(p) => p.theme.border};
    background-color: ${(p) => p.theme.offset};
    color: #888;
  }
`

const DateInput = forwardRef((props, ref) => {
  const {
    formKey,
    onChange,
    width,
    value,
    onEnter,
    onEscape,
    onArrowUp,
    onArrowDown,
    onKeyDown,
    placeholder,

    ...rest
  } = props

  return (
    <Input
      {...rest}
      type='date'
      width={width || '100%'}
      onChange={(e) => onChange(e.target.value)}
      value={value || ''}
      placeholder={placeholder || humanizeKey(formKey)}
      ref={ref}
    />
  )
})

DateInput.displayName = 'DateInput'

export default withFormValue(withLabel(DateInput))
